

























































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import Calendar from "@/components/calendar.vue";
import {Listen} from "@/utilities/decorators";
import Cta from "@/components/cta.vue";
import * as tel from "intl-tel-input";

import 'intl-tel-input/build/css/intlTelInput.css';

@Component({
    components: {Cta, Calendar}
}) export default class extends Vue {
    @Prop() data;

    calendarActive = false;
    dropdownActive = false;
    icons = [
        'l2t-icon-user',
        'l2t-icon-clock',
        'l2t-icon-calendar'
    ];
    tel;
    touched = false;

    get isTouched() {
        return this.touched;
    }

    setTouched(val) {
        this.touched = val;
    }

    beforeMount() {
        this.data.value = this.data.value;
    }

    @Watch('data') onDataChange() {
        if(this.tel) {
            this.tel.destroy();
        }

        this.transformPhone();
    }

    mounted() {
        this.transformPhone();

        if (this.data.events && this.$refs.input) {
            Object.keys(this.data.events).forEach((key) => {
                if(typeof this.data.events[key] === 'function') {
                    this.$subscriptions.push(
                        this.$eventManager.add(this.$refs.input, key, (e) => {
                            this.data.events[key](e, this.data.value, this.data);
                        })
                    );
                }
            });
        }
    }

    transformPhone() {
        if(this.data.controlType === 'phone') {
            this.tel = tel(this.$refs.input, {
                initialCountry: 'nl'
            });

            let input:any = this.$refs.input;

            window['intlTelInputGlobals'].loadUtils("https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/8.4.6/js/utils.js");
        }
    }


    get iconClassObj() {
        let obj = {};

        if (!this.data.icon) return obj;

        this.icons.forEach((icon) => {
            if (this.data.icon === icon) obj[icon] = true;
        });

        return obj;
    }

    onCounterClick(val) {
        if (val > this.data.value && val > 0 && val < this.data.config.min) val = this.data.config.min;

        if (val < this.data.value && val < this.data.config.min) val = 0;

        if (val >= 0 && val <= this.data.config.max) {
            this.setValue(val);
            this.forceEvent('change');
        }
    }

    onOptionClick(option) {
        this.data.value = option;
        this.setDropdownActive(false);
        this.forceEvent('change');
    }

    setValue(val) {
        this.data.value = val;
    }

    setDropdownActive(val) {
        this.dropdownActive = val;
    }

    @Listen('click') onClick() {
        this.setDropdownActive(false);
        this.setCalendarActive(false);
    }

    setCalendarActive(val) {
        this.calendarActive = val;
    }

    get isValid() {
        return this.data.validator(this.getValue(), this.data);
    }


    getIsValid() {
        return this.data.validator(this.getValue(), this.data);
    }

    getValue() {
        if(this.data.type === 'file') {
            return this.$refs.input['files'][0];
        } else  if(this.data.type === 'checkbox') {

            if(!this.$refs.input) return false;

            return this.$refs.input['checked'];
        } else if(this.data.controlType === 'phone') {

            if(!(this.data.value && this.data.value.length)) return false;
            return this.tel ? `${this.tel.selectedCountryData.dialCode} ${this.data.value}` : this.data.value;
        } else if(this.data.controlType === 'encrypted') {
            let el:any = document.querySelector(`[name="${this.data.config.encryptedKey}"]`);

            return el ? el.value : false;
        }

        return this.data.value;
    }

    onDateChange(val) {
        if (val) {
            this.data.value = val;
            this.setCalendarActive(false);
            this.forceEvent('change');
        }
    }

    forceEvent(name) {
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent(name, false, true);

        let input: any = this.$refs.input;

        input.dispatchEvent(evt);
    }

}
